import MuiCardContent, { CardContentProps as MuiCardContentProps } from '@mui/material/CardContent';
import React, { FC } from 'react';
import { BpDesignSystem } from '../../types';

export type CardContentProps = BpDesignSystem.PropsWithChildren<MuiCardContentProps & {}>;

export const CardContent: FC<CardContentProps> = ({ dataTest, ...props }) => (
  <MuiCardContent data-test={dataTest} {...props} />
);
